import script from "./unmatched_partner.vue?vue&type=script&setup=true&lang=js"
export * from "./unmatched_partner.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__